import React from "react";
import { FaHome } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { NavLink } from "react-router-dom";

const Deliver = ({
  from,
  status = "Pending", // API status: Pending, Delivered, Cancelled
  to,
  initial,
  title,
  date,
  descIcon,
  description,
  delType,
  delIcon,
  items,
  itemIcon,
  mealType,
  mealIcon,
  price,
  onDeliclick,
  onCanClick,
  formattedDate,
  canDeliver,
}) => {
  const isPending = status.toLowerCase() === "pending";
  const isDelivered = status.toLowerCase() === "delivered";
  const isCancelled = status.toLowerCase() === "cancelled";

  const isPastOrToday = (() => {
    if (!date) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const orderDate = new Date(date);
    orderDate.setHours(0, 0, 0, 0);

    return orderDate <= today; // 🔥 Main change here
  })();

  const deliverBtnClass =
    isPending && isPastOrToday
      ? "text-green-600 border border-green-200"
      : "text-gray-400 border border-gray-100";

  const formatTitle = (text, limit = 22) => {
    if (text.length <= limit) return text;
    return text.substring(0, limit) + "...";
  };

  return (
    <div
      className={`rounded-xl p-4 max-w-xl bg-white shadow-sm space-y-4 ${isPending ? "border border-[#FFDFA2]" : isCancelled ? "border  border-red-200 " : "border border-green-200 "}`}
    >
      <NavLink to={to} state={from} className="block space-y-2 md:space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <span className="px-2 py-2 border border-[#FFCCBF] rounded-md text-xs text-[#FF6943] font-semibold">
              {initial}
            </span>
            {/* <p className="text-[13px] md:text-sm font-bold text-[#191919]">
              {formatTitle(title, 18)}
            </p> */}
            <p className="text-[13px] md:text-sm font-bold text-[#191919]   line-clamp-1">
              {title}
            </p>
          </div>
          <span
            className={`text-[12px] md:text-sm px-2 py-1 rounded-xl font-medium
    ${
      isCancelled
        ? "bg-red-100 text-red-500"
        : isPending
          ? "bg-[#FFF0D6] text-[#FFB700]"
          : "bg-green-100 text-green-500"
    }
  `}
          >
            {formattedDate}
          </span>
        </div>

        {/* Description */}
        <div className="flex items-center gap-2 text-[#191919]">
          {descIcon && (
            <img src={descIcon} alt="desc icon" className="w-5 h-5" />
          )}
          <p className="text-[13px] md:text-sm">
            {/* {description || "Unknown Meal"} */}
            {description }
          </p>
        </div>

        {/* Details row */}
        <div className="flex items-center gap-6 text-[#191919]">
          <div className="flex items-center gap-1">
            {delIcon && (
              <img
                src={delIcon}
                alt="delivery icon"
                className="w-4 h-4 md:w-5 md:h-5"
              />
            )}
            <p className="text-[13px] md:text-sm">{delType}</p>
          </div>
          <div className="flex items-center gap-1">
            {itemIcon && (
              <img
                src={itemIcon}
                alt="item icon"
                className="w-4 h-4 md:w-5 md:h-5"
              />
            )}
            <p className="text-[13px] md:text-sm font-medium">{items}</p>
          </div>
          <div className="flex items-center gap-1">
            {mealIcon}
            <p className="text-[13px] md:text-sm">{mealType}</p>
          </div>
          <p className="text-sm font-semibold text-[#FF6943] ml-auto">
            {price}
          </p>
        </div>
      </NavLink>

      {/* Action buttons */}
      {(isPending || isDelivered) && (
        <div
          className="flex flex-row
      items-stretch
      gap-3
      pt-4
      border-t border-gray-200"
        >
          {isPending && (
            <button
              onClick={onDeliclick}
              className={`flex-1 flex items-center justify-center gap-2
      rounded-xl transition-all duration-300
      active:scale-[0.98]
      px-3 py-2 sm:px-4 sm:py-2.5
      text-xs sm:text-sm
      ${deliverBtnClass}
    `}
            >
              <FaHome className="text-sm sm:text-base" />
              <span className="whitespace-nowrap">Deliver Order</span>
            </button>
          )}

          <button
            onClick={onCanClick}
            className=" flex-1
        flex items-center justify-center gap-2
        rounded-xl
        border border-red-200
        text-red-600
        font-medium
        transition-all duration-300
        hover:bg-red-50
        active:scale-[0.98]

        px-3 py-2
        sm:px-4 sm:py-2.5
        text-xs sm:text-sm"
          >
            <FiX className="text-sm sm:text-base" />
            <span className="whitespace-nowrap">Cancel</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Deliver;
